import { createDependencyInjectableComponent } from "@faire/retailer-visitor-shared/app/_lib/dependencyInjectableComponent";
import { lazy } from "react";
var LazyLoggedOutCategoryPage = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "logged-out-category-page" */ "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/LoggedOutCategoryPage").then(function(m) {
        return {
            default: m.LoggedOutCategoryPage
        };
    });
});
var _createDependencyInjectableComponent = createDependencyInjectableComponent(LazyLoggedOutCategoryPage), useLoggedOutCategoryPage = _createDependencyInjectableComponent.useDependencyInjectableComponent, LoggedOutCategoryPageProvider = _createDependencyInjectableComponent.DependencyInjectableComponentProvider;
export { LoggedOutCategoryPageProvider, useLoggedOutCategoryPage };
